<main class="main" id="top">
  <div class="container" data-layout="container">
    <div class="row flex-center min-vh-80 py-2">
      <div class="col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">

        <a class="d-flex flex-center mb-4" href="#">
          <img class="mr-2" src="../../assets/img/illustrations/VMI_LOGO.png" alt="" width="250" />
        </a>

        <div class="card login-card-bg login-card-size slb-header">
          <div class="card-body p-4 p-sm-5 text-center">

            <h5 style="color:#fff;font-size:1.1rem" class="mb-3">
              Password Reset
            </h5>

            <div *ngIf="loading" class="mb-3">
              <div class="g_spinner mx-auto"></div>
            </div>

            <div class="reset-status"
                 [ngClass]="success ? 'text-success' : 'text-warning'">
              {{ message }}
            </div>

            <div class="fs-12 text-light mt-3">
              Redirecting to login page in 5 seconds...
            </div>

          </div>
        </div>

        <div class="login-help-text">
          If you experience any issues, please contact us at
          <a href="mailto:ithelp@iosc.az">ithelp@iosc.az</a>
        </div>

      </div>
    </div>
  </div>
</main>
